import React, { useState, useEffect } from "react";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useParams } from "react-router-dom";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { projectFirestore } from "../../../../firebase-config/config";
import "./PGSecurityOneVisitorLogs.scss";

const PGSecurityOneVisitorDetails = () => {
  const { id } = useParams();

  // Fetch the visitor document from Firestore
  const { document: visitorDoc } = useDocument("visitors", id);
  const [userDocs, setUserDocs] = useState(null);
  const [createdByUser, setCreatedByUser] = useState(null);

  useEffect(() => {
    const fetchCreatedByDoc = async () => {
      if (visitorDoc?.phoneNumber) {
        try {
          const docRef = projectFirestore
            .collection("users")
            .doc(visitorDoc.createdBy);
          const docSnap = await docRef.get();
          if (docSnap.exists) {
            setCreatedByUser({ id: docSnap.id, ...docSnap.data() });
          } else {
            setCreatedByUser(null);
          }
        } catch (error) {
          console.error("Error fetching user document:", error);
        }
      }
    };

    const fetchUserDoc = async () => {
      if (visitorDoc?.phoneNumber) {
        try {
          const docRef = projectFirestore
            .collection("users")
            .doc(visitorDoc.phoneNumber);
          const docSnap = await docRef.get();
          if (docSnap.exists) {
            setUserDocs({ id: docSnap.id, ...docSnap.data() });
          } else {
            setUserDocs(null);
          }
        } catch (error) {
          console.error("Error fetching user document:", error);
        }
      }
    };
    fetchUserDoc();
    fetchCreatedByDoc();
  }, [visitorDoc]);

  return (
    <div className="security-one-visitor-details-parent container">
      <div className="d-flex justify-content-center security-one-visitor-details-div">
        <img
          src={
            userDocs?.registeredFaceUrl ||
            localStorage.getItem("unmatchedFace") ||
            "/assets/img/men-icon-login.png"
          }
          alt="your registred face"
          className="security-one-visitor-details-img"
        />
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ marginTop: "30px" }}
      >
        {userDocs && (
          <>
            {userDocs.gender === "male" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path d="M400-80v-280h-80v-240q0-33 23.5-56.5T400-680h160q33 0 56.5 23.5T640-600v240h-80v280H400Zm80-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Z" />
              </svg>
            )}
            {userDocs.gender === "female" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="currentColor"
              >
                <path d="M400-80v-240H280l122-308q10-24 31-38t47-14q26 0 47 14t31 38l122 308H560v240H400Zm80-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Z" />
              </svg>
            )}
          </>
        )}

        <p style={{ textTransform: "capitalize" }}>
          {userDocs && userDocs.gender}
        </p>
      </div>

      {/* peoples group counter start */}
      <div className="security-one-visitor-peoples-parent">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ fontWeight: "700" }}
        >
          Total Visitors: {visitorDoc && visitorDoc.totalVisitors}
        </div>
      </div>
      {/* peoples group counter end */}

      {/* VISITOR DETAILS */}
      <div className="security-one-visitor-details-body">
        <span className="security-one-strip">VISITOR DETAILS</span>
        <input type="text" value={userDocs && userDocs.fullName} disabled />
        <input type="text" value={userDocs && userDocs.phoneNumber} disabled />
        <input type="email" value={userDocs && userDocs.email} disabled />
      </div>

      {/* PURPOSE OF VISIT */}
      <div className="security-one-visitor-details-body">
        <span className="security-one-strip">PURPOSE OF VISIT</span>
        <input type="text" value={visitorDoc && visitorDoc.purpose} disabled />
        <input type="text" value={visitorDoc && visitorDoc.remarks} disabled />
      </div>

      {/* HOST DETAILS */}
      <div className="security-one-visitor-details-body">
        <span className="security-one-strip">HOST DETAILS</span>
        <input type="text" value={visitorDoc && visitorDoc.hostName} disabled />
        <input
          type="text"
          value={visitorDoc && visitorDoc.hostMobileNumber}
          disabled
        />
        <input
          type="email"
          value={visitorDoc && visitorDoc.hostEmail}
          disabled
        />
      </div>

      {/* CREATED BY */}
      {visitorDoc && visitorDoc.visitorExitTimeStamp === "" && (
        <div className="security-one-visitor-details-body">
          <span className="security-one-strip">CREATED BY</span>
          <input
            type="text"
            value={createdByUser && createdByUser.fullName}
            disabled
          />
          <input
            type="text"
            value={createdByUser && createdByUser.phoneNumber}
            disabled
          />
          <input
            type="text"
            value={
              visitorDoc &&
              visitorDoc.createdAt &&
              visitorDoc &&
              visitorDoc.createdAt
                .toDate()
                .toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                .replace("", "")
                .replace(",", ", ")
            }
            disabled
          />
        </div>
      )}
    </div>
  );
};

export default PGSecurityOneVisitorDetails;
